var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#fb0;}.cls-3{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-4{opacity:0.25;mix-blend-mode:multiply;}.cls-5,.cls-6{mix-blend-mode:overlay;}.cls-6{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.27,44.25A29.67,29.67,0,0,1,37.88,61.11a29.23,29.23,0,0,1-4.52.34A29.64,29.64,0,0,1,26.64,3c.7-.15,1.38-.29,2.09-.4A29.64,29.64,0,0,0,55.64,44.62,29.42,29.42,0,0,0,60.27,44.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.27,44.25A29.67,29.67,0,0,1,37.88,61.11a29.23,29.23,0,0,1-4.52.34A29.64,29.64,0,0,1,26.64,3c.7-.15,1.38-.29,2.09-.4A29.64,29.64,0,0,0,55.64,44.62,29.42,29.42,0,0,0,60.27,44.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadow",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.73,31.82A29.64,29.64,0,0,1,28.1,4c.19-.49.4-1,.63-1.47-.71.11-1.39.25-2.09.4a29.64,29.64,0,0,0,6.72,58.5c.85,0,1.7,0,2.53-.11A29.64,29.64,0,0,1,8.73,31.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Highligth",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M60.27,44.25a29.42,29.42,0,0,1-4.63.37l-.55,0A29.62,29.62,0,0,1,32.88,61.11c-.66.1-1.32.17-2,.23.82.07,1.64.11,2.47.11a29.47,29.47,0,0,0,16.1-4.75A29.73,29.73,0,0,0,60.27,44.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M26,15A29.58,29.58,0,0,1,28.73,2.55c-.71.11-1.39.25-2.09.4A32.18,32.18,0,0,0,23.1,4a29.64,29.64,0,0,0,27.54,40.6c.85,0,1.68,0,2.51-.12A29.63,29.63,0,0,1,26,15Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.be1d695e8c9ad02c87df52677cbb4160.svg";
export { ForwardRef as ReactComponent };